export class UpdateEmployee {
  public Empno: string;
  public updateItems: UpdatedItems;
  constructor(d: any = {}, data: any = {}) {
    this.Empno = d.employeeId || "";
    this.updateItems = new UpdatedItems(d, data) || new UpdatedItems({}, {});
  }
}

export class UpdatedItems {
  public Empno: string;
  public Empname: string;
  public RMCode: string;
  public RMname: string;
  public EmailID: string;
  public Role: string;
  public Team: string;
  public userObj: object;

  constructor(d: any = {}, data: any = {}) {
    this.Empno = data.employeeId || "";
    this.Empname = data.employeeName || "";
    this.RMCode = data.reportingManagerId || "";
    this.RMname = data.reportingManagerName || "";
    this.EmailID = data.emailId || "";
    this.Role = data.reportingManager ? "RM" : "EMP";
    this.Team = data.team ? data.team : "";
    this.userObj = {};
  }
}

export class AddEmployee {
  public Empno: string;
  public Empname: string;
  public RMCode: string;
  public RMname: string;
  public EmailID: string;
  public Role: string;
  public userObj: object;
  constructor(data: any = {}) {
    this.Empno = data.employeeId;
    this.Empname = data.employeeName;
    this.RMCode = data.reportingManagerId;
    this.RMname = data.reportingManagerName;
    this.EmailID = data.emailId;
    this.Role = data.reportingManager ? "RM" : "EMP";
    this.userObj = {};
  }
}
export class ExportEmployee {
  public "Employee Name": string;
  public "Employee Id": number;
  public "Email Id": string;
  public "Reporting Manager": string;
  public "RM Id": number;
  public "Role": string;
  constructor(d: any = {}) {
    this["Employee Name"] = d.employeeDetails.Empname || "";
    this["Employee Id"] = d.employeeDetails.Empno_legacy || null;
    this["Email Id"] = d.employeeDetails.EmailID || "";
    this["Reporting Manager"] = d.employeeDetails.RMname || "";
    this["RM Id"] = d.employeeDetails.RMCode || "";
    this["Role"] = d.employeeDetails.Role || "";
  }
}

export class ExportIpdoEmployee {
  public "Emp Name": string;
  public "Emp Id": number;
  public "Emp Status": string;
  public "Personnel Area": string;
  public "Personnel Sub Area": string;
  public "Employee Sub Group": string;
  public "Email Id": string;
  public "Reporting Manager": string;
  public "RM Id": number;
  public "Role": string;
  public "Team": string;
  constructor(d: any = {}, businessUnit) {
    this["Employee Name"] = d.employeeDetails.Empname || "";
    this["Employee Id"] = d.employeeDetails.Empno_legacy || null;
     this["Email Id"] = d.employeeDetails.EmailID || "";
     this["RMname"] = d.employeeDetails.RMname || "";
    this["RM EmailID"] = d.employeeDetails.Manager_Email_Id
    || "";
    this["L+2 name"]=d.employeeDetails.L_Plus_2_name ||"";
    this["L+2 EmailID"]=d.employeeDetails.L_Plus_2 ||"";
    this["Role"] = d.employeeDetails.Role || "";
    this["EmpDepartment"] =
      d.employeeDetails.EmpDepartment || "";
      this["No of Projects"]=d.projectCount || 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/employees/employee.ts